/**
 * Native startup bootstrap.
 *
 * Called once from `main.tsx` before React renders. Handles the platform-level
 * setup that doesn't need React context: status-bar styling, splash-screen
 * dismissal, and connectivity monitoring. Feature init that needs the router or
 * auth state (deep links, push) is wired from AuthProvider instead.
 *
 * Every call is guarded so this is a harmless no-op on the web.
 */

import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { initNetworkMonitor } from '@/store/useNetworkStore';
import { isNativePlatform } from './platform';

export async function bootstrapNative(): Promise<void> {
  // Connectivity monitoring runs on every platform (Network plugin degrades to
  // browser online/offline events on the web).
  void initNetworkMonitor();

  if (!isNativePlatform()) return;

  try {
    // Dark-on-light status bar to match the light app canvas. The header sits
    // below the safe-area inset (see index.css .pt-safe-top).
    await StatusBar.setStyle({ style: Style.Light });
  } catch {
    /* status bar plugin unavailable — ignore */
  }

  try {
    await SplashScreen.hide();
  } catch {
    /* splash already hidden — ignore */
  }
}
